import m from "../../geodata/es2015/czechiaHigh";
window.am4geodata_czechiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/czechiaHigh.js
// module id = null
// module chunks = 